import type { z } from 'zod'
import type { paymentInfoForGtmSchema, paymentInfoForDataLayerSchema } from '@/schemas/payment'

export interface Payment {
  id: number
  amount: number
  // eslint-disable-next-line camelcase
  creation_date: Date
  name: string
}

export enum PaymentMethod {
  online = 2,
  traditional = 1
}

export enum PaymentType {
  fundraising = 3,
  instalments = 2,
  purchase = 1,
  fundraisingDonate = 4
}

export enum PayerType {
  person = 'person',
  company = 'company'
}

export enum PaymentDataLayerName {
  purchase = 'ap_indeks_całość',
  instalments = 'ap_indeks_raty',
  fundraising = 'ap_indeks_zbiórka',
  fundraisingDonate = 'ap_indeks_dokładam się'
}

export enum PaymentDataLayerSku {
  purchase = 21,
  instalments = 22,
  fundraising = 23,
  fundraisingDonate = 24
}

export type PaymentDataLayerDetails = {
  sku: PaymentDataLayerSku
  name: PaymentDataLayerName
}

export type PaymentDataLayer = { [key in PaymentType]: PaymentDataLayerDetails }

export type PaymentInfoForGtm = z.infer<typeof paymentInfoForGtmSchema>

export type PaymentInfoForDataLayer = z.infer<typeof paymentInfoForDataLayerSchema>
